import services from 'utils/mockAdapter';
// user list
const Models = [
    {
        id: '10011',
        name: 'Eclipse ',
        description: 'Eclipse Home Evevator'
    },
    {
        id: '10012',
        name: 'Infinity ',
        description: 'Eclipse Home Evevator'
    },
    {
        id: '10011',
        name: 'Eclipse ',
        description: 'Eclipse Home Evevator'
    },
    {
        id: '10011',
        name: 'Eclipse ',
        description: 'Eclipse Home Evevator'
    },
    {
        id: '10011',
        name: 'Eclipse ',
        description: 'Eclipse Home Evevator'
    },
    {
        id: '10011',
        name: 'Eclipse ',
        description: 'Eclipse Home Evevator'
    },
    {
        id: '10011',
        name: 'Eclipse ',
        description: 'Eclipse Home Evevator'
    },
    {
        id: '10011',
        name: 'Eclipse ',
        description: 'Eclipse Home Evevator'
    },
    {
        id: '10011',
        name: 'Eclipse ',
        description: 'Eclipse Home Evevator'
    },
    {
        id: '10011',
        name: 'Eclipse ',
        description: 'Eclipse Home Evevator'
    },
    {
        id: '10011',
        name: 'Eclipse ',
        description: 'Eclipse Home Evevator'
    },
    {
        id: '10011',
        name: 'Eclipse ',
        description: 'Eclipse Home Evevator'
    },
    {
        id: '10011',
        name: 'Eclipse ',
        description: 'Eclipse Home Evevator'
    }
];
// ==============================|| MOCK SERVICES ||============================== //
services.onGet('/api/manufacturers/models/list').reply(200, { Models });
